import React, { useEffect, useState } from 'react';
import { Button, Title } from '@cognite/cogs.js';
import { Icon } from 'components/Icon';
import Select from 'react-select';
import { useQuery } from 'react-query';
import { useStoreState } from 'hooks';
import axios from 'axios';

type Props = {
  move: (project: string) => void;
};

/**
 * Taken from https://github.com/cognitedata/cdf-hub-tenant-selector
 */
const ProjectTitle = () => (
  <Title level={5} style={{ marginBottom: 4, marginTop: 16 }}>
    Project
  </Title>
);

export default function ProjectSelect({ move }: Props) {
  const token = useStoreState((state) => state.auth.token);
  const cluster = useStoreState((state) => state.auth.cluster);

  const [selectedProject, setSelectedProject] = useState<string | undefined>(
    undefined
  );
  const baseUrl = `https://${cluster || 'api'}.cognitedata.com/api/v1/`;
  const { data = [], isFetched } = useQuery<string[]>(
    [baseUrl, 'projects'],
    async () => {
      const result = await axios.get(`${baseUrl}projects`, {
        headers: {
          authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return result.data?.items?.map((p: { urlName: string }) => p.urlName);
    }
  );

  useEffect(() => {
    if (!selectedProject && data.length > 0) {
      setSelectedProject(data[0]);
    }
  }, [data, selectedProject]);

  if (isFetched && data.length === 0) {
    return (
      <>
        <ProjectTitle />

        <p>
          <Icon type="Error" style={{ marginRight: 10, color: '#e32351' }} />
          You are successfully logged in, but no projects were found. Make sure
          you have access to a CDF project.
        </p>
      </>
    );
  }

  if (isFetched && data.length > 0) {
    const options = data.map((d) => ({ value: d, label: d }));
    const selected = options.find((p) => p.value === selectedProject);

    return (
      <>
        <ProjectTitle />
        <Select
          style={{ margin: '20px 0' }}
          value={selected}
          options={options}
          onChange={(e) => setSelectedProject(e?.value)}
        />
        <Button
          style={{ marginTop: '16px' }}
          type="primary"
          disabled={!selectedProject || !selected?.value}
          onClick={() => {
            if (selectedProject) {
              move(selectedProject);
            }
          }}
        >
          Continue
        </Button>
      </>
    );
  }
  return <></>;
}
